import * as Yup from 'yup';
import { formatCurrency } from '../../../../../utils/CurrencyUtils';

export const amountRegex = new RegExp('^[-+]?[0-9]*[$.,]?[0-9]+$');
export const inputValidatorRegEx = /^\s*-?(\d+(\.\d{1,2})?|\.\d{1,2})\s*$/;

export const autopayDetailsFormValidationSchema = Yup.object().shape({
  paymentAmountDueType: Yup.string().required(
    'Amount Due selection is Required'
  ),
  paymentMinimumAmountDue: Yup.string().required(
    'Amount Due selection is Required'
  ),
  paymentOtherAmountDue: Yup.string().when('paymentAmountDueType', {
    is: 'other',
    then: Yup.string()
      .required('Amount Due Entry is Required')
      .matches(inputValidatorRegEx, 'Enter a valid amount')
      .test(
        'max amount test',
        `Please enter a valid amount of $2999.99 or less. If you’d like to pay your loan in full, please contact Bridgecrest or visit Bridgecrest.com.`,
        (val) => Number(val) < 3000
      )
      .when('paymentMinimumAmountDue', (paymentMinimumAmountDue, schema) => {
        return schema.test({
          test: (paymentOtherAmountDue: any) =>
            Number(paymentOtherAmountDue) >= Number(paymentMinimumAmountDue),
          message: `This doesn't cover your regular monthly payment. To use Autopay you must enter an amount of ${formatCurrency(
            paymentMinimumAmountDue
          )} or larger.`,
        });
      }),
  }),
  paymentDueDate: Yup.string().required('Due Date selection is Required'),
  paymentConsent: Yup.bool().oneOf([true], 'Consent is required to continue'),
});
